import { render, staticRenderFns } from "./SmooHeader.vue?vue&type=template&id=b7fce04a&"
import script from "./SmooHeader.ts?vue&type=script&lang=ts&"
export * from "./SmooHeader.ts?vue&type=script&lang=ts&"
import style0 from "./SmooHeader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports